import { connect } from "react-redux";
import { Selectors } from "@/store/masterSearch/selectors";
import { Selectors as UserSelectors } from "@/store/user/selectors";
import { Actions } from "@/store/masterSearch/slice";
import loadable from "@loadable/component";

const SearchAside = loadable(
  () =>
    import(
      /* webpackChunkName: "search-page-aside" */
      "."
    ),
  {
    ssr: false,
  }
);

const mSp = (state) => ({
  mapPopup: Selectors.getMapPopup(state),
  mapFocus: Selectors.getMapFocus(state),
  coords: Selectors.getLocCoords(state),
  hasCoords: Selectors.hasCoords(state),
  isMapOpen: Selectors.isMapOpen(state),
  isFiltersOpen: Selectors.isFiltersOpen(state),
  masters: Selectors.getGeoResults(state),
  locale: UserSelectors.getLocale(state),
  resultsLength: Selectors.getResultsLength(state),
});
const mDp = {
  openMapPopup: Actions.openMapPopup,
  closeMapPopup: Actions.closeMapPopup,
  toggleMap: Actions.toggleMap,
  toggleFilters: Actions.toggleFilters,
};
export default connect(mSp, mDp)(SearchAside);
